var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendAllToggleOn = function SvgSendAllToggleOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 21,
    viewBox: "0 0 36 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 1,
    y: 3.5,
    width: 34,
    height: 14,
    rx: 7,
    fill: "#FFC83E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 10.5,
    r: 10,
    fill: "#F0AC00"
  })));
};
export { SvgSendAllToggleOn as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAzNiAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgb3BhY2l0eT0iMC41IiB4PSIxIiB5PSIzLjUiIHdpZHRoPSIzNCIgaGVpZ2h0PSIxNCIgcng9IjciIGZpbGw9IiNGRkM4M0UiLz4KPGNpcmNsZSBjeD0iMjUiIGN5PSIxMC41IiByPSIxMCIgZmlsbD0iI0YwQUMwMCIvPgo8L3N2Zz4K";